// extracted by mini-css-extract-plugin
export var csatScore = "_mu-5";
export var header = "_mu-1";
export var panelWrapper = "_mu-2";
export var postPreview = "_mu-3";
export var rightContent = "_mu-0";
export var wrappingText = "_mu-4";